import { NgModule } from '@angular/core';
import { Components } from '@app/shared-modules/list/components';

@NgModule({
    declarations: [Components],
    exports: [Components],
})
export class ListModule {}
